// extracted by mini-css-extract-plugin
export default {"container":"Error_container__+1XVK","mainTitle":"Error_mainTitle__Sjgyh","secondTitle":"Error_secondTitle__tJlD7","btn":"Error_btn__5oSbn"};